export default __webpack_public_path__ + "static/media/Tahoma.d8d06950.ttf";